import { createAsyncThunk } from '@reduxjs/toolkit';
import { loadProjectAndSubProjectBulletins } from 'scenes/BulletinBoard/store/thunks/loadProjectAndSubProjectBulletins';
import {
  SUBCONTRACTORS_RECORDS_VIEW,
  WORK_CALENDAR_VIEW_ALL_OWN_BUSINESS_RECORDS,
} from 'scenes/Permissions/constants/permissions';
import { selectIsRequiredBusinessPermissionFromCurrentActiveEmployerBusiness } from 'scenes/Permissions/store/selectors/personalPermissionsSelectors';
import { loadAllCurrentUserPermissions } from 'scenes/Permissions/store/thunks/loadAllCurrentUserPermissions.thunk';
import { setSelectedProjectId } from 'scenes/Project/store/actions/projectActions';
import { setProject } from 'store/actions/setProject';
import { loadApprovalGroupsByProject } from 'store/approvals/thunks/loadApprovalGroupsByProject';
import { loadAllowancesOfCurrentUserEmployers } from 'store/employerAllowances/thunks/loadAllowancesOfCurrentUserEmployers.thunk';
import { selectSelectedProject } from 'store/projects/selectors/projectsSelectors';
import { clearSelectedRecords } from 'store/records/actions/records.actions';
import { selectUserActiveEmployerBusinessId } from 'store/user/selectors.js/user.selectors';
import {
  setPersonalWorkCalendarMode,
  setSelectionMode,
} from '../actions/demoActions';
import { loadAdminInitialDataInTimeFrame } from './loadAdminInitialDataInTimeFrame';
import { loadInitialCalendarData } from './loadInitialCalendarData.thunk';
import { loadInitialCalendarDataForAdmin } from './loadInitialCalendarDataForAdmin.thunk';
import { loadSubcontractorEmployeeData } from './loadSubcontractorEmployeeData.thunk';
import { loadSubcontractorRecordsData } from './loadSubcontractorRecordsData.thunk';
import { loadWorkCalendarWorkTimeSaldoInformationInTimeframe } from './loadWorkCalendarWorkTimeSaldoInformationInTimeframe.thunk';

export const initWorkCalendar = createAsyncThunk(
  'project/initWorkCalendar',
  async ({ projectId, viewMode }, { dispatch, getState }) => {
    dispatch(setProject({ id: projectId }));
    dispatch(setSelectedProjectId(projectId));
    dispatch(clearSelectedRecords());
    if (viewMode === 'invoice') {
      dispatch(setSelectionMode(true));
    } else {
      dispatch(setSelectionMode(false));
    }
    dispatch(loadProjectAndSubProjectBulletins());
    dispatch(setPersonalWorkCalendarMode(false));
    dispatch(loadAllowancesOfCurrentUserEmployers());

    dispatch(loadWorkCalendarWorkTimeSaldoInformationInTimeframe());

    await dispatch(loadAllCurrentUserPermissions());
    dispatch(loadApprovalGroupsByProject(projectId));

    const isPermissionFromActiveEmployerToViewSubcontractorRecords =
      selectIsRequiredBusinessPermissionFromCurrentActiveEmployerBusiness(
        getState(),
        SUBCONTRACTORS_RECORDS_VIEW
      );

    const isPermissionFromActiveEmployerToViewAllBusinessRecords =
      selectIsRequiredBusinessPermissionFromCurrentActiveEmployerBusiness(
        getState(),
        WORK_CALENDAR_VIEW_ALL_OWN_BUSINESS_RECORDS
      );

    const selectedProject = selectSelectedProject(getState());

    const activeEmployerBusinessId =
      selectUserActiveEmployerBusinessId(getState());

    if (
      isPermissionFromActiveEmployerToViewAllBusinessRecords &&
      activeEmployerBusinessId === selectedProject.business_id
    ) {
      await dispatch(loadAdminInitialDataInTimeFrame());
      dispatch(loadInitialCalendarDataForAdmin());
    } else {
      if (isPermissionFromActiveEmployerToViewSubcontractorRecords) {
        console.log('IS PERMISSION, SEARCH SUBCONTRACTORS');
        await Promise.allSettled([
          dispatch(loadInitialCalendarData()),
          dispatch(loadSubcontractorEmployeeData()),
          dispatch(loadSubcontractorRecordsData()),
        ]);
      } else {
        await dispatch(loadInitialCalendarData());
      }
    }
  }
);
